import { LogOut, UserCircle } from 'lucide-react';
import type { AuthUser } from '@/context/AuthContext';

interface NavbarProps {
  user: AuthUser | null;
  tenantName: string;
  onLogout: () => void;
}

export function Navbar({ user, tenantName, onLogout }: NavbarProps) {
  return (
    <header
      style={{
        height: 56,
        background: 'var(--color-surface)',
        borderBottom: '1px solid var(--color-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 1.5rem',
        flexShrink: 0,
      }}
    >
      {/* Izquierda: nombre del tenant */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span
          style={{
            fontSize: '0.75rem',
            fontWeight: 500,
            color: 'var(--color-muted)',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
          }}
        >
          Empresa
        </span>
        <span style={{ color: 'var(--color-border)' }}>/</span>
        <span
          style={{
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: 'var(--color-text)',
          }}
        >
          {tenantName}
        </span>
      </div>

      {/* Derecha: usuario + logout */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <UserCircle size={18} color="var(--color-muted)" />
          <span
            style={{
              fontSize: '0.8125rem',
              color: 'var(--color-text)',
              fontWeight: 500,
            }}
          >
            {user?.name ?? user?.email ?? 'Usuario'}
          </span>
          {user?.role && (
            <span
              style={{
                fontSize: '0.6875rem',
                background: 'var(--color-badge-bg)',
                color: 'var(--color-accent)',
                borderRadius: 4,
                padding: '1px 6px',
                fontWeight: 600,
                textTransform: 'capitalize',
              }}
            >
              {user.role}
            </span>
          )}
        </div>

        <button
          onClick={onLogout}
          aria-label="Cerrar sesion"
          title="Cerrar sesion"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            background: 'transparent',
            border: '1px solid var(--color-border)',
            borderRadius: 6,
            padding: '0.3125rem 0.625rem',
            cursor: 'pointer',
            color: 'var(--color-muted)',
            fontSize: '0.75rem',
            transition: 'border-color 0.15s, color 0.15s',
          }}
        >
          <LogOut size={14} />
          Salir
        </button>
      </div>
    </header>
  );
}
